import * as React from 'react'
import clsx from 'clsx'
import styles from './index.module.scss'
import { SxProps, sx as sxFunc } from '../sx'

type ThemeContextProp = string

export const ThemeContext = React.createContext<ThemeContextProp>('')

interface ThemeProviderProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'green' | 'blue'
  sx?: SxProps
}

export const ThemeProvider = (props: ThemeProviderProps) => {
  const { className, children, variant = 'blue', sx, ...other } = props
  return (
    <ThemeContext.Provider value={styles[`theme-${variant}`] ?? ''}>
      <div
        className={clsx(styles[`theme-${variant}`], className, sxFunc(sx))}
        {...other}
      >
        {children}
      </div>
    </ThemeContext.Provider>
  )
}

export const useCurrentTheme = () => {
  return React.useContext(ThemeContext)
}
